<template>
  <form @submit.prevent="handleSubmit" id="asset_create_form" enctype="multipart/form-data">

    <!-- Asset Name -->
    <div class="mb-4">
      <label class="form-label form-label-thin">Asset Name <span class="text-danger">*</span></label>
      <input type="text" class="form-control form-control-thin" id="name" name="name" v-model="form.name" ref="name"
        placeholder="Asset Name" />
    </div>

    <div class="mb-4">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <label class="form-label form-label-thin mb-0">
          Category <span class="text-danger">*</span>
        </label>

        <button type="button" class="btn btn-sm btn-link text-primary text-decoration-none p-0"
          @click="openCreateCategoryModal">
          <i class="fa fa-plus-circle me-1"></i>
          Add Category
        </button>
      </div>

      <MultiSelect v-model="form.category" :multiple="false" :options="categories" label-key="name"
        value-key="external_id" placeholder="Select Category" ref="category" />
    </div>

    <!-- Create Category Modal -->
    <FormModal ref="createCategoryModal" title="Create New Category" id="create_category_form_modal">
      <CreateCategory ref="CreateCategoryForm" @created="onCategoryCreated" @close="closeCreateCategoryModal" />
    </FormModal>
    <!-- Code -->
    <div class="mb-4">
      <label class="form-label form-label-thin">Code <span class="text-danger">*</span></label>
      <input type="text" class="form-control form-control-thin" id="code" name="code" v-model="form.code" ref="code"
        placeholder="Asset Code" />
    </div>

    <!-- Purchase Date -->
    <div class="mb-4">
      <label class="form-label form-label-thin">Purchase Date <span class="text-danger">*</span></label>
      <input type="date" class="form-control form-control-thin" id="purchase_date" name="purchase_date"
        v-model="form.purchase_date" ref="purchase_date" />
    </div>

    <!-- Vendors -->
    <div class="mb-4">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <label class="form-label form-label-thin mb-0">
          Vendors
        </label>

        <button type="button" class="btn btn-sm btn-link text-primary text-decoration-none p-0"
          @click="openCreateVendorModal">
          <i class="fa fa-plus-circle me-1"></i>
          Add Vendor
        </button>
      </div>

      <MultiSelect v-model="form.vendor_ids" :options="vendors" placeholder="Select vendors…" ref="vendor_ids" />
      <FormModal ref="createVendorModal" title="Create New Vendor" id="create_vendor_form_modal">
        <CreateVendor ref="createVendorForm" @created="onVendorCreated" @close="closeCreateVendorModal" />
      </FormModal>
    </div>

    <div class="mb-4">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <label class="form-label form-label-thin mb-0">
          Materials <span class="text-danger">*</span>
        </label>

        <button type="button" class="btn btn-sm btn-link text-primary text-decoration-none p-0"
          @click="openCreateMaterialModal">
          <i class="fa fa-plus-circle me-1"></i>
          Add Material
        </button>
      </div>

      <MultiSelect v-model="form.material_ids" :multiple="true" :groups="dropdownCategories" group-label-key="name"
        group-children-key="materials" child-value-key="id" child-label-key="name" placeholder="Select materials…"
        ref="material_ids" />
    </div>

    <FormModal ref="createMaterialModal" title="Create New Material" id="create_material_form_modal">
      <CreateMaterial ref="CreateMaterialForm" @created="onMaterialCreated" @close="closeCreateMaterialModal" />
    </FormModal>

    <!-- Criticality -->
    <div class="mb-4">
      <MultiSelect v-model="form.criticality" :multiple="false" label="Criticality" ref="criticality">
        <option value="">Select Criticality</option>
        <option value="low">Low</option>
        <option value="medium">Medium</option>
        <option value="high">High</option>
      </MultiSelect>
    </div>

    <!-- Serial Number -->
    <div class="mb-4">
      <label class="form-label form-label-thin">Serial Number <span class="text-danger">*</span></label>
      <input type="text" class="form-control form-control-thin" id="serial_number" name="serial_number"
        v-model="form.serial_number" ref="serial_number" placeholder="Serial Number" />
    </div>

    <!-- Model -->
    <div class="mb-4">
      <label class="form-label form-label-thin">Model <span class="text-danger">*</span></label>
      <input type="text" class="form-control form-control-thin" id="model" name="model" v-model="form.model" ref="model"
        placeholder="Model" />
    </div>

    <!-- Manufacturer -->
    <div class="mb-4">
      <label class="form-label form-label-thin">Manufacturer <span class="text-danger">*</span></label>
      <input type="text" class="form-control form-control-thin" id="manufacturer" name="manufacturer"
        v-model="form.manufacturer" ref="manufacturer" placeholder="Manufacturer" />
    </div>

    <!-- Description -->
    <div class="mb-4">
      <label class="form-label form-label-thin">Description (If Any)</label>
      <textarea class="form-control form-control-thin" id="description" name="description" v-model="form.description"
        ref="description" rows="3" placeholder="Asset Description"></textarea>
    </div>

    <!-- Location -->
    <div class="mb-4">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <label class="form-label form-label-thin mb-0">
          Location
        </label>

        <button type="button" class="btn btn-sm btn-link text-primary text-decoration-none p-0"
          @click="openCreateLocationModal">
          <i class="fa fa-plus-circle me-1"></i>
          Add Location
        </button>
      </div>

      <MultiSelect v-model="form.location" :multiple="false" :options="locations" label-key="name"
        value-key="external_id" placeholder="Select Location" ref="location" />
    </div>

    <!-- Create Location Modal -->
    <FormModal ref="createLocationModal" title="Create New Location" id="create_location_form_modal">
      <CreateLocation ref="createLocationForm"  :Parentlocations="Parentlocations"  @created="onLocationCreated" @close="closeCreateLocationModal" />
    </FormModal>

    <!-- Photo -->
    <div class="mb-4">
      <label class="form-label form-label-thin">Photo</label>

      <input type="file" class="form-control form-control-thin" id="photo" name="photo" ref="photo"
        @change="onPhotoChange" accept="image/*" />

      <div v-if="form.photo_preview" class="mt-2">
        <img :src="form.photo_preview" alt="Preview"
          style="max-width: 200px; max-height: 200px; border-radius: 6px; border: 1px solid #e5e7eb;" />

        <div>
          <button type="button" class="btn btn-link btn-sm text-danger p-0 mt-1" style="font-size:11px;"
            @click="clearPhoto">
            <i class="fa fa-times"></i> Clear
          </button>
        </div>
      </div>
    </div>

    <!-- File -->
    <div class="mb-4">
      <label class="form-label form-label-thin">Attachment File</label>

      <input type="file" class="form-control form-control-thin" id="file" name="file" ref="file"
        @change="onFileChange" />

      <small class="text-muted">Max size: 20MB</small>
    </div>

    <!-- Modal Footer -->
    <div class="d-flex justify-content-end gap-2">
      <button type="button" class="btn btn-sm btn-outline-secondary hover-white" @click="close">
        <i class="fa fa-times"></i> Cancel
      </button>

      <button type="submit" class="btn btn-primary py-1 px-2 text-light hover-white btn-sm form-submit-btn"
        :disabled="submitting">
        <i class="fa fa-save"></i>
        {{ submitting ? 'Creating...' : 'Create Asset' }}
      </button>
    </div>

  </form>
</template>

<script>
import { form_api_submit } from '@/utils/FormSubmit'
import MultiSelect from '@/components/MultiSelect.vue'
import FormModal from '@/components/utils/FormModal.vue'
import CreateMaterial from '@/views/Materials/CreateMaterial.vue'
import CreateCategory from '@/views/Asset/Category/CreateCategory.vue'
import CreateVendor from '@/views/Vendor/CreateVendor.vue'
import CreateLocation from '@/views/Location/CreateLocation.vue'
export default {
  name: 'CreateAsset',
  emits: ['created', 'close'],
  components: {
    MultiSelect,
    FormModal,
    CreateCategory,
    CreateMaterial,
    CreateVendor,
    CreateLocation,
  },

  data() {
    return {
      form: {
        name: '',
        category: '',
        code: '',
        purchase_date: '',
        criticality: '',
        serial_number: '',
        model: '',
        manufacturer: '',
        description: '',
        location: '',
        photo: null,
        photo_preview: null,
        file: null,
        vendor_ids: [],
        material_ids: [],
      },
      submitting: false,
      categories: [],
      locations: [],
      vendors: [],
      dropdownCategories: [],
      Parentlocations: [],
    }
  },

  mounted() {
    this.get_categories()
    this.get_locations()
    this.get_vendors()
    this.get_materials()
      this.fetchParentLocations()
  },

  methods: {
    async handleSubmit() {
      this.submitting = true

      const fd = new FormData()
      const scalars = ['name', 'code', 'purchase_date', 'criticality',
        'serial_number', 'model', 'manufacturer', 'description',
        'location', 'category']
      scalars.forEach(key => {
        if (this.form[key] !== null && this.form[key] !== '') {
          fd.append(key, this.form[key])
        }
      })

      this.form.vendor_ids.forEach(id => fd.append('vendor_ids[]', id))
      this.form.material_ids.forEach(id => fd.append('material_ids[]', id))

      if (this.form.photo instanceof File) {
        fd.append('photo', this.form.photo)
      }

      if (this.form.file instanceof File) {
        fd.append('file', this.form.file)
      }

      const result = await form_api_submit({
        url: 'asset/create',
        method: 'POST',
        data: fd,
        curr_form_id: '#asset_create_form',
      })

      if (result.success) {
        this.$emit('created', {
          asset: result.data.data
        })
        this.close()
        this.resetForm()
      }

      this.submitting = false
    },

    // ── Photo handlers ──────────────────────────────────────────────────────
    onPhotoChange(e) {
      const file = e.target.files[0]
      if (!file) return

      if (file.size > 10 * 1024 * 1024) {
        e.target.value = ''
        return
      }

      this.form.photo = file
      this.form.photo_preview = URL.createObjectURL(file)
    },

    clearPhoto() {
      this.form.photo = null
      this.form.photo_preview = null
    },

    // ── File handlers ────────────────────────────────────────────────────────
    onFileChange(e) {
      const file = e.target.files[0]
      if (!file) return

      if (file.size > 20 * 1024 * 1024) {
        e.target.value = ''
        return
      }

      this.form.file = file
    },

    // ── Dropdown fetchers ──────────────────────────────────────────────────
    async get_categories() {
      const result = await form_api_submit({
        url: 'asset/category/dropdown',
        method: 'GET',
        data: {},
        show_success_toast: false,
        show_error_toast: true,
      })

      if (result.success) {
        this.categories = result.data || []
      }
    },

    async get_locations() {
      const result = await form_api_submit({
        url: 'locations/dropdown',
        method: 'GET',
        data: {},
        show_success_toast: false,
        show_error_toast: true,
      })

      if (result.success) {
        this.locations = result.data || []
      }
    },
    openCreateLocationModal() {
      this.$refs.createLocationModal.showModal()
    },

    closeCreateLocationModal() {
      this.$refs.createLocationModal.closeModal()
    },

    async onLocationCreated(locationData) {
      await this.get_locations()

      this.closeCreateLocationModal()

      if (
        locationData &&
        locationData.location &&
        locationData.location.external_id
      ) {
        const newLocation = this.locations.find(
          l => l.external_id === locationData.location.external_id
        )

        if (newLocation) {
          this.form.location = newLocation.external_id
        }
      }
    },
    async get_vendors() {
      try {
        const result = await form_api_submit({
          url: 'vendor/get-vendors',
          method: 'GET',
          show_success_toast: false,
          show_error_toast: false,
        })

        if (result?.success) {
          this.vendors = (result.data || []).map(vendor => ({
            value: vendor.id,
            label: vendor.first_name || vendor.get_profile?.company_name || 'Vendor',
          }))
        }
      } catch (error) {
        console.error('Failed to load vendors', error)
      }
    },
 async fetchParentLocations() {
      this.loading = true

      const result = await form_api_submit({
        url: 'locations/get-locations',
        method: 'GET',
        data: {},
        show_success_toast: false,
        show_error_toast: true,
        remove_pre_toasts: false
      })

      if (result.success) {
        this.Parentlocations = result.data
      }

      this.loading = false
    },
    async get_materials() {
      try {
        const result = await form_api_submit({
          url: 'materials/dropdown',
          method: 'GET',
          show_success_toast: false,
          show_error_toast: false,
        })

        if (result?.success) {
          const grouped = Object.values(
            (result.data || []).reduce((groups, material) => {
              const type = material.type || 'Other'

              if (!groups[type]) {
                groups[type] = {
                  name: type.charAt(0).toUpperCase() + type.slice(1),
                  materials: []
                }
              }

              groups[type].materials.push(material)

              return groups
            }, {})
          )

          this.dropdownCategories = grouped
        }
      } catch (error) {
        console.error('Failed to load materials', error)
      }
    },
    openCreateCategoryModal() {
      this.$refs.createCategoryModal.showModal()
    },

    closeCreateCategoryModal() {
      this.$refs.createCategoryModal.closeModal()
    },

    async onCategoryCreated(categoryData) {
      await this.get_categories()

      this.closeCreateCategoryModal()

      if (
        categoryData &&
        categoryData.category &&
        categoryData.category.external_id
      ) {
        const newCategory = this.categories.find(
          c => c.external_id === categoryData.category.external_id
        )

        if (newCategory) {
          this.form.category = newCategory.external_id
        }
      }
    },
    openCreateMaterialModal() {
      this.$refs.createMaterialModal.showModal()
    },

    closeCreateMaterialModal() {
      this.$refs.createMaterialModal.closeModal()
    },

    async onMaterialCreated(materialData) {
      await this.get_materials()

      this.closeCreateMaterialModal()

      if (
        materialData &&
        materialData.material &&
        materialData.material.id
      ) {
        // Find the material inside the grouped structure
        let newMaterial = null

        for (const group of this.dropdownCategories) {
          newMaterial = group.materials.find(
            m => m.id === materialData.material.id
          )

          if (newMaterial) break
        }

        if (newMaterial) {
          if (!Array.isArray(this.form.material_ids)) {
            this.form.material_ids = []
          }

          this.form.material_ids.push(newMaterial.id)
        }
      }
    },
    openCreateVendorModal() {
      this.$refs.createVendorModal.showModal()
    },

    closeCreateVendorModal() {
      this.$refs.createVendorModal.closeModal()
    },

    async onVendorCreated(vendorData) {
      await this.get_vendors()

      this.closeCreateVendorModal()

      if (
        vendorData &&
        vendorData.vendor &&
        vendorData.vendor.external_id
      ) {
        const newVendor = this.vendors.find(
          v => v.external_id === vendorData.vendor.external_id
        )

        if (newVendor) {
          if (!Array.isArray(this.form.vendor_ids)) {
            this.form.vendor_ids = []
          }

          this.form.vendor_ids.push(newVendor.id)
        }
      }
    },
    close() {
      this.$emit('close')
    },

    resetForm() {
      this.form = {
        name: '',
        category: '',
        code: '',
        purchase_date: '',
        criticality: '',
        serial_number: '',
        model: '',
        manufacturer: '',
        description: '',
        location: '',
        photo: null,
        photo_preview: null,
        file: null,
        vendor_ids: [],
        material_ids: []
      }
    }
  }
}
</script>

<style scoped>
.modal-footer {
  padding: 16px 0 0 0;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.hover-white:hover {
  color: #ffffff !important;
}
</style>